module.exports = __webpack_public_path__ + "static/media/10974199_10205799534688089_605331760909110310_o.9d7bea4b.jpg";